/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.

// You should NOT make any changes in this file as it will be overwritten.

// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as TransactionStatusRouteImport } from './routes/transaction-status';
import { Route as RampsRouteImport } from './routes/ramps';
import { Route as IndexRouteImport } from './routes/index';
import { Route as RampsIndexRouteImport } from './routes/ramps.index';
import { Route as RampsStatusRouteImport } from './routes/ramps.status';
import { Route as RampsReviewRouteImport } from './routes/ramps.review';
import { Route as RampsPhoneRouteImport } from './routes/ramps.phone';
import { Route as RampsNameRouteImport } from './routes/ramps.name';
import { Route as RampsKycVerificationRouteImport } from './routes/ramps.kyc-verification';
import { Route as RampsIdentificationRouteImport } from './routes/ramps.identification';
import { Route as RampsDigitalOfframpInfoRouteImport } from './routes/ramps.digital-offramp-info';
import { Route as RampsDepositLocationRouteImport } from './routes/ramps.deposit-location';
import { Route as RampsDepositRouteImport } from './routes/ramps.deposit';
import { Route as RampsDateOfBirthRouteImport } from './routes/ramps.date-of-birth';
import { Route as RampsCancelSuccessRouteImport } from './routes/ramps.cancel-success';
import { Route as RampsCancelRouteImport } from './routes/ramps.cancel';
import { Route as RampsCalculatorRouteImport } from './routes/ramps.calculator';
import { Route as RampsAddressRouteImport } from './routes/ramps.address';
import { Route as RampsAdditionalInfoRouteImport } from './routes/ramps.additional-info';

const TransactionStatusRoute = TransactionStatusRouteImport.update({
  id: '/transaction-status',
  path: '/transaction-status',
  getParentRoute: () => rootRouteImport,
} as any);
const RampsRoute = RampsRouteImport.update({
  id: '/ramps',
  path: '/ramps',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const RampsIndexRoute = RampsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RampsRoute,
} as any);
const RampsStatusRoute = RampsStatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => RampsRoute,
} as any);
const RampsReviewRoute = RampsReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => RampsRoute,
} as any);
const RampsPhoneRoute = RampsPhoneRouteImport.update({
  id: '/phone',
  path: '/phone',
  getParentRoute: () => RampsRoute,
} as any);
const RampsNameRoute = RampsNameRouteImport.update({
  id: '/name',
  path: '/name',
  getParentRoute: () => RampsRoute,
} as any);
const RampsKycVerificationRoute = RampsKycVerificationRouteImport.update({
  id: '/kyc-verification',
  path: '/kyc-verification',
  getParentRoute: () => RampsRoute,
} as any);
const RampsIdentificationRoute = RampsIdentificationRouteImport.update({
  id: '/identification',
  path: '/identification',
  getParentRoute: () => RampsRoute,
} as any);
const RampsDigitalOfframpInfoRoute = RampsDigitalOfframpInfoRouteImport.update({
  id: '/digital-offramp-info',
  path: '/digital-offramp-info',
  getParentRoute: () => RampsRoute,
} as any);
const RampsDepositLocationRoute = RampsDepositLocationRouteImport.update({
  id: '/deposit-location',
  path: '/deposit-location',
  getParentRoute: () => RampsRoute,
} as any);
const RampsDepositRoute = RampsDepositRouteImport.update({
  id: '/deposit',
  path: '/deposit',
  getParentRoute: () => RampsRoute,
} as any);
const RampsDateOfBirthRoute = RampsDateOfBirthRouteImport.update({
  id: '/date-of-birth',
  path: '/date-of-birth',
  getParentRoute: () => RampsRoute,
} as any);
const RampsCancelSuccessRoute = RampsCancelSuccessRouteImport.update({
  id: '/cancel-success',
  path: '/cancel-success',
  getParentRoute: () => RampsRoute,
} as any);
const RampsCancelRoute = RampsCancelRouteImport.update({
  id: '/cancel',
  path: '/cancel',
  getParentRoute: () => RampsRoute,
} as any);
const RampsCalculatorRoute = RampsCalculatorRouteImport.update({
  id: '/calculator',
  path: '/calculator',
  getParentRoute: () => RampsRoute,
} as any);
const RampsAddressRoute = RampsAddressRouteImport.update({
  id: '/address',
  path: '/address',
  getParentRoute: () => RampsRoute,
} as any);
const RampsAdditionalInfoRoute = RampsAdditionalInfoRouteImport.update({
  id: '/additional-info',
  path: '/additional-info',
  getParentRoute: () => RampsRoute,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/ramps': typeof RampsRouteWithChildren;
  '/transaction-status': typeof TransactionStatusRoute;
  '/ramps/additional-info': typeof RampsAdditionalInfoRoute;
  '/ramps/address': typeof RampsAddressRoute;
  '/ramps/calculator': typeof RampsCalculatorRoute;
  '/ramps/cancel': typeof RampsCancelRoute;
  '/ramps/cancel-success': typeof RampsCancelSuccessRoute;
  '/ramps/date-of-birth': typeof RampsDateOfBirthRoute;
  '/ramps/deposit': typeof RampsDepositRoute;
  '/ramps/deposit-location': typeof RampsDepositLocationRoute;
  '/ramps/digital-offramp-info': typeof RampsDigitalOfframpInfoRoute;
  '/ramps/identification': typeof RampsIdentificationRoute;
  '/ramps/kyc-verification': typeof RampsKycVerificationRoute;
  '/ramps/name': typeof RampsNameRoute;
  '/ramps/phone': typeof RampsPhoneRoute;
  '/ramps/review': typeof RampsReviewRoute;
  '/ramps/status': typeof RampsStatusRoute;
  '/ramps/': typeof RampsIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/transaction-status': typeof TransactionStatusRoute;
  '/ramps/additional-info': typeof RampsAdditionalInfoRoute;
  '/ramps/address': typeof RampsAddressRoute;
  '/ramps/calculator': typeof RampsCalculatorRoute;
  '/ramps/cancel': typeof RampsCancelRoute;
  '/ramps/cancel-success': typeof RampsCancelSuccessRoute;
  '/ramps/date-of-birth': typeof RampsDateOfBirthRoute;
  '/ramps/deposit': typeof RampsDepositRoute;
  '/ramps/deposit-location': typeof RampsDepositLocationRoute;
  '/ramps/digital-offramp-info': typeof RampsDigitalOfframpInfoRoute;
  '/ramps/identification': typeof RampsIdentificationRoute;
  '/ramps/kyc-verification': typeof RampsKycVerificationRoute;
  '/ramps/name': typeof RampsNameRoute;
  '/ramps/phone': typeof RampsPhoneRoute;
  '/ramps/review': typeof RampsReviewRoute;
  '/ramps/status': typeof RampsStatusRoute;
  '/ramps': typeof RampsIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/ramps': typeof RampsRouteWithChildren;
  '/transaction-status': typeof TransactionStatusRoute;
  '/ramps/additional-info': typeof RampsAdditionalInfoRoute;
  '/ramps/address': typeof RampsAddressRoute;
  '/ramps/calculator': typeof RampsCalculatorRoute;
  '/ramps/cancel': typeof RampsCancelRoute;
  '/ramps/cancel-success': typeof RampsCancelSuccessRoute;
  '/ramps/date-of-birth': typeof RampsDateOfBirthRoute;
  '/ramps/deposit': typeof RampsDepositRoute;
  '/ramps/deposit-location': typeof RampsDepositLocationRoute;
  '/ramps/digital-offramp-info': typeof RampsDigitalOfframpInfoRoute;
  '/ramps/identification': typeof RampsIdentificationRoute;
  '/ramps/kyc-verification': typeof RampsKycVerificationRoute;
  '/ramps/name': typeof RampsNameRoute;
  '/ramps/phone': typeof RampsPhoneRoute;
  '/ramps/review': typeof RampsReviewRoute;
  '/ramps/status': typeof RampsStatusRoute;
  '/ramps/': typeof RampsIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/ramps'
    | '/transaction-status'
    | '/ramps/additional-info'
    | '/ramps/address'
    | '/ramps/calculator'
    | '/ramps/cancel'
    | '/ramps/cancel-success'
    | '/ramps/date-of-birth'
    | '/ramps/deposit'
    | '/ramps/deposit-location'
    | '/ramps/digital-offramp-info'
    | '/ramps/identification'
    | '/ramps/kyc-verification'
    | '/ramps/name'
    | '/ramps/phone'
    | '/ramps/review'
    | '/ramps/status'
    | '/ramps/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/transaction-status'
    | '/ramps/additional-info'
    | '/ramps/address'
    | '/ramps/calculator'
    | '/ramps/cancel'
    | '/ramps/cancel-success'
    | '/ramps/date-of-birth'
    | '/ramps/deposit'
    | '/ramps/deposit-location'
    | '/ramps/digital-offramp-info'
    | '/ramps/identification'
    | '/ramps/kyc-verification'
    | '/ramps/name'
    | '/ramps/phone'
    | '/ramps/review'
    | '/ramps/status'
    | '/ramps';
  id:
    | '__root__'
    | '/'
    | '/ramps'
    | '/transaction-status'
    | '/ramps/additional-info'
    | '/ramps/address'
    | '/ramps/calculator'
    | '/ramps/cancel'
    | '/ramps/cancel-success'
    | '/ramps/date-of-birth'
    | '/ramps/deposit'
    | '/ramps/deposit-location'
    | '/ramps/digital-offramp-info'
    | '/ramps/identification'
    | '/ramps/kyc-verification'
    | '/ramps/name'
    | '/ramps/phone'
    | '/ramps/review'
    | '/ramps/status'
    | '/ramps/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  RampsRoute: typeof RampsRouteWithChildren;
  TransactionStatusRoute: typeof TransactionStatusRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/transaction-status': {
      id: '/transaction-status';
      path: '/transaction-status';
      fullPath: '/transaction-status';
      preLoaderRoute: typeof TransactionStatusRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/ramps': {
      id: '/ramps';
      path: '/ramps';
      fullPath: '/ramps';
      preLoaderRoute: typeof RampsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/ramps/': {
      id: '/ramps/';
      path: '/';
      fullPath: '/ramps/';
      preLoaderRoute: typeof RampsIndexRouteImport;
      parentRoute: typeof RampsRoute;
    };
    '/ramps/status': {
      id: '/ramps/status';
      path: '/status';
      fullPath: '/ramps/status';
      preLoaderRoute: typeof RampsStatusRouteImport;
      parentRoute: typeof RampsRoute;
    };
    '/ramps/review': {
      id: '/ramps/review';
      path: '/review';
      fullPath: '/ramps/review';
      preLoaderRoute: typeof RampsReviewRouteImport;
      parentRoute: typeof RampsRoute;
    };
    '/ramps/phone': {
      id: '/ramps/phone';
      path: '/phone';
      fullPath: '/ramps/phone';
      preLoaderRoute: typeof RampsPhoneRouteImport;
      parentRoute: typeof RampsRoute;
    };
    '/ramps/name': {
      id: '/ramps/name';
      path: '/name';
      fullPath: '/ramps/name';
      preLoaderRoute: typeof RampsNameRouteImport;
      parentRoute: typeof RampsRoute;
    };
    '/ramps/kyc-verification': {
      id: '/ramps/kyc-verification';
      path: '/kyc-verification';
      fullPath: '/ramps/kyc-verification';
      preLoaderRoute: typeof RampsKycVerificationRouteImport;
      parentRoute: typeof RampsRoute;
    };
    '/ramps/identification': {
      id: '/ramps/identification';
      path: '/identification';
      fullPath: '/ramps/identification';
      preLoaderRoute: typeof RampsIdentificationRouteImport;
      parentRoute: typeof RampsRoute;
    };
    '/ramps/digital-offramp-info': {
      id: '/ramps/digital-offramp-info';
      path: '/digital-offramp-info';
      fullPath: '/ramps/digital-offramp-info';
      preLoaderRoute: typeof RampsDigitalOfframpInfoRouteImport;
      parentRoute: typeof RampsRoute;
    };
    '/ramps/deposit-location': {
      id: '/ramps/deposit-location';
      path: '/deposit-location';
      fullPath: '/ramps/deposit-location';
      preLoaderRoute: typeof RampsDepositLocationRouteImport;
      parentRoute: typeof RampsRoute;
    };
    '/ramps/deposit': {
      id: '/ramps/deposit';
      path: '/deposit';
      fullPath: '/ramps/deposit';
      preLoaderRoute: typeof RampsDepositRouteImport;
      parentRoute: typeof RampsRoute;
    };
    '/ramps/date-of-birth': {
      id: '/ramps/date-of-birth';
      path: '/date-of-birth';
      fullPath: '/ramps/date-of-birth';
      preLoaderRoute: typeof RampsDateOfBirthRouteImport;
      parentRoute: typeof RampsRoute;
    };
    '/ramps/cancel-success': {
      id: '/ramps/cancel-success';
      path: '/cancel-success';
      fullPath: '/ramps/cancel-success';
      preLoaderRoute: typeof RampsCancelSuccessRouteImport;
      parentRoute: typeof RampsRoute;
    };
    '/ramps/cancel': {
      id: '/ramps/cancel';
      path: '/cancel';
      fullPath: '/ramps/cancel';
      preLoaderRoute: typeof RampsCancelRouteImport;
      parentRoute: typeof RampsRoute;
    };
    '/ramps/calculator': {
      id: '/ramps/calculator';
      path: '/calculator';
      fullPath: '/ramps/calculator';
      preLoaderRoute: typeof RampsCalculatorRouteImport;
      parentRoute: typeof RampsRoute;
    };
    '/ramps/address': {
      id: '/ramps/address';
      path: '/address';
      fullPath: '/ramps/address';
      preLoaderRoute: typeof RampsAddressRouteImport;
      parentRoute: typeof RampsRoute;
    };
    '/ramps/additional-info': {
      id: '/ramps/additional-info';
      path: '/additional-info';
      fullPath: '/ramps/additional-info';
      preLoaderRoute: typeof RampsAdditionalInfoRouteImport;
      parentRoute: typeof RampsRoute;
    };
  }
}

interface RampsRouteChildren {
  RampsAdditionalInfoRoute: typeof RampsAdditionalInfoRoute;
  RampsAddressRoute: typeof RampsAddressRoute;
  RampsCalculatorRoute: typeof RampsCalculatorRoute;
  RampsCancelRoute: typeof RampsCancelRoute;
  RampsCancelSuccessRoute: typeof RampsCancelSuccessRoute;
  RampsDateOfBirthRoute: typeof RampsDateOfBirthRoute;
  RampsDepositRoute: typeof RampsDepositRoute;
  RampsDepositLocationRoute: typeof RampsDepositLocationRoute;
  RampsDigitalOfframpInfoRoute: typeof RampsDigitalOfframpInfoRoute;
  RampsIdentificationRoute: typeof RampsIdentificationRoute;
  RampsKycVerificationRoute: typeof RampsKycVerificationRoute;
  RampsNameRoute: typeof RampsNameRoute;
  RampsPhoneRoute: typeof RampsPhoneRoute;
  RampsReviewRoute: typeof RampsReviewRoute;
  RampsStatusRoute: typeof RampsStatusRoute;
  RampsIndexRoute: typeof RampsIndexRoute;
}

const RampsRouteChildren: RampsRouteChildren = {
  RampsAdditionalInfoRoute: RampsAdditionalInfoRoute,
  RampsAddressRoute: RampsAddressRoute,
  RampsCalculatorRoute: RampsCalculatorRoute,
  RampsCancelRoute: RampsCancelRoute,
  RampsCancelSuccessRoute: RampsCancelSuccessRoute,
  RampsDateOfBirthRoute: RampsDateOfBirthRoute,
  RampsDepositRoute: RampsDepositRoute,
  RampsDepositLocationRoute: RampsDepositLocationRoute,
  RampsDigitalOfframpInfoRoute: RampsDigitalOfframpInfoRoute,
  RampsIdentificationRoute: RampsIdentificationRoute,
  RampsKycVerificationRoute: RampsKycVerificationRoute,
  RampsNameRoute: RampsNameRoute,
  RampsPhoneRoute: RampsPhoneRoute,
  RampsReviewRoute: RampsReviewRoute,
  RampsStatusRoute: RampsStatusRoute,
  RampsIndexRoute: RampsIndexRoute,
};

const RampsRouteWithChildren = RampsRoute._addFileChildren(RampsRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  RampsRoute: RampsRouteWithChildren,
  TransactionStatusRoute: TransactionStatusRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
